import * as XLSX from "xlsx";

export class ExcelHelper {
  static ExportToExcel(exportData: any[], sheetName: string, fileName: string) {
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    XLSX.writeFile(workbook, fileName);
  }
}
